interface Props {
  size?: number;
}

export default function XrpIcon(props: Props) {
  const { size = 21 } = props;

  return (
    <svg
      width={size}
      height={size}
      css="flex-shrink: 0"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z"
        fill="white"
      />
      <path
        d="M15.4492 4.7031H17.4726L13.2617 8.87247C11.7367 10.3816 9.26429 10.3816 7.73823 8.87247L3.52565 4.7031H5.55073L8.74995 7.87033C9.71985 8.82624 11.2776 8.82624 12.2475 7.87033L15.4492 4.7031Z"
        fill="#23292F"
      />
      <path
        d="M5.52475 16.2969H3.49995L7.73823 12.1018C9.26319 10.5927 11.7356 10.5927 13.2617 12.1018L17.5 16.2969H15.4765L12.25 13.1039C11.2801 12.148 9.72231 12.148 8.75241 13.1039L5.52475 16.2969Z"
        fill="#23292F"
      />
    </svg>
  );
}
